import type { TableColumnType } from '@gitbook/doc-core';
import { createPalette, PaletteCommandType, type PaletteDef } from '@gitbook/react-uikit';

import { definitionSpecs, orderedDefinitionTypes } from './definitions';

/**
 * Create a palette to pick a type.
 */
export function createColumnDefsPalette(
    pickType: (type: TableColumnType) => void,
    opts: {
        selectedType?: TableColumnType;
    } = {}
): PaletteDef {
    return createPalette({
        groups: [
            {
                key: 'types',
                commands: orderedDefinitionTypes.map((type) => {
                    const spec = definitionSpecs[type];

                    return {
                        key: type,
                        icon: spec.icon,
                        title: spec.title,
                        type: PaletteCommandType.RADIO,
                        selected: opts.selectedType === type,
                        trigger: () => {
                            if (opts.selectedType !== type) {
                                pickType(type);
                            }
                        },
                    };
                }),
            },
        ],
    });
}
